import _extends from "@babel/runtime/helpers/extends";
/**
 * @name Atom One
 * Atom One dark syntax theme
 *
 * https://github.com/atom/one-dark-syntax
 */
import { tags as t } from '@lezer/highlight';
import { createTheme } from '@uiw/codemirror-themes';
export var defaultSettingsAtomone = {
  background: '#272C35',
  foreground: '#9d9b97',
  caret: '#797977',
  selection: '#3d4c64',
  selectionMatch: '#3d4c64',
  gutterBackground: '#272C35',
  gutterForeground: '#465063',
  gutterBorder: 'transparent',
  lineHighlight: '#2e3f5940'
};
export var atomoneDarkStyle = [{
  tag: [t.function(t.variableName), t.function(t.propertyName), t.url, t.processingInstruction],
  color: 'hsl(207, 82%, 66%)'
}, {
  tag: [t.tagName, t.heading],
  color: '#e06c75'
}, {
  tag: t.comment,
  color: '#54636D'
}, {
  tag: [t.propertyName],
  color: 'hsl(220, 14%, 71%)'
}, {
  tag: [t.attributeName, t.number],
  color: 'hsl( 29, 54%, 61%)'
}, {
  tag: t.className,
  color: 'hsl( 39, 67%, 69%)'
}, {
  tag: t.keyword,
  color: 'hsl(286, 60%, 67%)'
}, {
  tag: [t.string, t.regexp, t.special(t.propertyName)],
  color: '#98c379'
}];
export var atomoneInit = options => {
  var _ref = options || {},
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? {} : _ref$settings,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles;
  return createTheme({
    theme: theme,
    settings: _extends({}, defaultSettingsAtomone, settings),
    styles: [...atomoneDarkStyle, ...styles]
  });
};
export var atomone = atomoneInit();